export default __webpack_public_path__ + "static/media/T750_CoC.b0f608c0.pdf";